import { FC, ReactNode } from 'react';

import { isNullOrUndefined } from '@telialt/utils/src/helpers';

import { RetailsTestID } from '../../test-ids';
import { SuggestionItemWrapper } from './CitySearch.styles';

type Props = {
    label: ReactNode;
    count?: number;
    onClick: () => void;
};

export const SuggestionItem: FC<Props> = ({ label, count, onClick }) => {
    return (
        <SuggestionItemWrapper onClick={onClick} role="option" data-test={RetailsTestID.CITY_SEARCH_SUGGESTION_ITEM}>
            <div>{label}</div>
            {!isNullOrUndefined(count) && <div>{count}</div>}
        </SuggestionItemWrapper>
    );
};
